import TextField from "@material-ui/core/TextField";
import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import IntlTelInput from "react-intl-tel-input";
import MaskedInput from "react-text-mask";

import { disabledProps } from "../../../util/formHelpers";

class PhoneInput extends React.Component {
  handleCountryChange = (_, value) => {
    this.props.onCountryChange(null, value.iso2.toUpperCase());
  };

  handlePhoneChange = (e) => {
    this.props.onPhoneChange(null, e.target.value.replace(/[^0-9]/g, ""));
  };

  maskedPhoneInput(props) {
    const { inputRef, ...other } = props;

    return (
      <MaskedInput
        {...other}
        ref={inputRef}
        mask={[
          "(",
          /[1-9]/,
          /\d/,
          /\d/,
          ")",
          " ",
          /\d/,
          /\d/,
          /\d/,
          "-",
          /\d/,
          /\d/,
          /\d/,
          /\d/,
        ]}
        placeholderChar={"\u2000"}
        style={{ border: "none" }}
        data-cy="textfield-phoneInput"
      />
    );
  }

  renderLabel() {
    return (
      <div
        className={`static-input-label${this.props.error ? " error" : ""}`}
        style={{ padding: 0, lineHeight: "initial" }}
      >
        {this.props.label}
      </div>
    );
  }

  textInputProps() {
    let res = /us/i.test(this.props.phone_prefix)
      ? {
        inputComponent: this.maskedPhoneInput,
      }
      : {};

    if (this.props.disabled) {
      res = { ...res, ...disabledProps(true).InputProps };
    }

    return res;
  }

  renderPrefixDropdown() {
    const { phone_prefix } = this.props;

    if (this.props.disabled) {
      return (
        <div
          className="intl-tel-input"
          style={{ position: "absolute", height: 36 }}
        >
          <div className="selected-flag" tabIndex={0}>
            <div
              className={classnames(
                "iti-flag",
                (this.props.phone_prefix || "us").toLowerCase()
              )}
            />
          </div>
        </div>
      );
    }
    return (
      <IntlTelInput
        css={["intl-tel-input"]}
        preferredCountries={["us"]}
        defaultCountry={(phone_prefix && phone_prefix.toLowerCase()) || "us"}
        onSelectFlag={this.handleCountryChange}
        style={{ height: "36px", position: "absolute" }}
        telInputProps={{
          style: { visibility: "hidden", width: "50px" },
        }}
        utilsScript="libphonenumber.js"
      />
    );
  }

  render() {
    return (
      <div
        className="ie11-phone-div"
        style={{ position: "relative", height: "51px", marginBottom: 20 }}
      >
        {this.props.label && this.renderLabel()}
        {this.renderPrefixDropdown()}
        <TextField
          error={this.props.error}
          helperText={this.props.helperText}
          InputProps={this.textInputProps()}
          onChange={this.handlePhoneChange}
          onBlur={this.props.onBlur}
          style={{
            marginLeft: this.props.disabled ? 0 : 5,
            left: this.props.disabled ? "38px" : "48px",
            top: this.props.disabled ? "2px" : "0px",
            width: "calc(100% - 48px)",
          }}
          value={this.props.phone}
        />
      </div>
    );
  }
}

PhoneInput.defaultProps = {
  disabled: false,
};

PhoneInput.propTypes = {
  onCountryChange: PropTypes.func,
  onPhoneChange: PropTypes.func,
  phone: PropTypes.string,
  phone_ext: PropTypes.string,
  disabled: PropTypes.bool,
};

export default PhoneInput;
